import { EventEmitter, Injectable } from '@angular/core';
import { ToastModel } from '@syncfusion/ej2-notifications';
import { ResponseCardModel, ResponseType } from '../../models/toasts/response-card-model';
import { ToastErrorModel } from '../../models/toasts/toast-error.model';
import { ToastInfoModel } from '../../models/toasts/toast-info.model';
import { ToastSuccesModel } from '../../models/toasts/toast-succes.model';
import { ToastWarningModel } from '../../models/toasts/toast-warning.model';

@Injectable({
  providedIn: 'root',
})
export class NotificationToastService {
  notificationToastEvent = new EventEmitter<ToastModel>();

  push(toast: ToastModel) {
    return this.notificationToastEvent.next(toast);
  }

  pushFromCard(card: ResponseCardModel) {
    this.push(this.makeToastModelFromCard(card));
  }

  makeToastModelFromCard(card: ResponseCardModel): ToastModel
  {
      switch (card.type) {
        case ResponseType.erreur: return new ToastErrorModel(card.message);
        case ResponseType.succes: return new ToastSuccesModel(card.message);
        case ResponseType.info: return new ToastInfoModel(card.message);
        case ResponseType.warning: return new ToastWarningModel(card.message);
      }
  }

  constructor() {}
}
